var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 52,
    viewBox: "0 0 24 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7663 13.7892C21.3159 13.2396 21.3159 12.3486 20.7663 11.799C20.2167 11.2494 19.3257 11.2494 18.7761 11.799L13.4073 17.1678L13.4073 1.99019C13.4073 1.21297 12.7772 0.582914 12 0.582913C11.2228 0.582915 10.5927 1.21297 10.5927 1.99019L10.5927 17.1678L5.22388 11.799C4.6743 11.2494 3.78326 11.2494 3.23369 11.799C2.68411 12.3486 2.68411 13.2396 3.23369 13.7892L11.0049 21.5604C11.5545 22.11 12.4455 22.11 12.9951 21.5604L20.7663 13.7892Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23369 38.2108C2.68411 38.7604 2.68411 39.6514 3.23369 40.201C3.78326 40.7506 4.6743 40.7506 5.22388 40.201L10.5927 34.8322L10.5927 50.0098C10.5927 50.787 11.2228 51.4171 12 51.4171C12.7772 51.4171 13.4073 50.787 13.4073 50.0098L13.4073 34.8322L18.7761 40.201C19.3257 40.7506 20.2167 40.7506 20.7663 40.201C21.3159 39.6514 21.3159 38.7604 20.7663 38.2108L12.9951 30.4396C12.4455 29.89 11.5545 29.89 11.0049 30.4396L3.23369 38.2108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.906cb17efd70b09773ea20b6a4ac0247.svg";
export { ForwardRef as ReactComponent };